
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.nb-product-hero').forEach(section => {
    const mainMedia = section.querySelector('[data-nb-main-media]');
    const thumbs = [...section.querySelectorAll('[data-nb-thumb]')];

    const optionButtons = [...section.querySelectorAll('[data-nb-plan]')];
    const quantityBox = section.querySelector('[data-nb-quantity-box]');
    const addButton = section.querySelector('[data-nb-add-link]');
    const price = section.querySelector('[data-nb-price]');

    const minus = section.querySelector('[data-nb-qty-minus]');
    const plus = section.querySelector('[data-nb-qty-plus]');
    const input = section.querySelector('[data-nb-qty-input]');

    let currentPlan = 'one-time';

    // GALERIE
    function selectImage(thumb) {
      if (!mainMedia || !thumb?.dataset.src) return;

      const image = mainMedia.querySelector('img');
      if (!image) return;

      thumbs.forEach(item => {
        item.classList.toggle('is-active', item === thumb);
        item.setAttribute(
          'aria-pressed',
          String(item === thumb)
        );
      });

      image.src = thumb.dataset.src;

      const thumbnailImage = thumb.querySelector('img');
      image.alt = thumbnailImage?.alt || 'Photo du produit Nutriboo';
    }

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => selectImage(thumb));
    });

    // QUANTITÉ
    function getQuantity() {
      if (!input) return 1;

      let quantity = parseInt(input.value, 10);

      if (!Number.isFinite(quantity)) quantity = 1;

      quantity = Math.max(1, Math.min(99, quantity));
      input.value = String(quantity);

      return quantity;
    }

    // ACHAT
    function updatePurchase() {
      if (!addButton) return;

      const subscription = currentPlan === 'subscription';

      optionButtons.forEach(button => {
        const selected = button.dataset.nbPlan === currentPlan;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', String(selected));
      });

      quantityBox?.classList.toggle('is-hidden', subscription);

      if (price) {
        price.textContent = subscription
          ? price.dataset.subscriptionPrice || ''
          : price.dataset.oneTimePrice || '';
      }

      const baseUrl = subscription
        ? addButton.dataset.subscriptionUrl
        : addButton.dataset.oneTimeUrl;

      if (!baseUrl) {
        addButton.removeAttribute('href');
        addButton.setAttribute('aria-disabled', 'true');
        return;
      }

      const url = new URL(baseUrl, window.location.origin);

      url.searchParams.set(
        'quantity',
        String(subscription ? 1 : getQuantity())
      );

      addButton.href = url.pathname + url.search;
      addButton.removeAttribute('aria-disabled');
    }

    optionButtons.forEach(button => {
      button.addEventListener('click', () => {
        currentPlan = button.dataset.nbPlan === 'subscription'
          ? 'subscription'
          : 'one-time';

        updatePurchase();
      });
    });

    minus?.addEventListener('click', () => {
      if (!input) return;
      input.value = String(Math.max(1, getQuantity() - 1));
      updatePurchase();
    });

    plus?.addEventListener('click', () => {
      if (!input) return;
      input.value = String(Math.min(99, getQuantity() + 1));
      updatePurchase();
    });

    input?.addEventListener('input', () => {
      input.value = input.value.replace(/\D/g, '');
      if (input.value !== '') updatePurchase();
    });

    input?.addEventListener('blur', updatePurchase);

    updatePurchase();
  });
});
